import { useQuery, UseQueryResult } from "react-query"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import ResponseError from "utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { DocumentStatus } from "../../../types/DocumentStatus"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetDocumentStatues"

export default function useDocumentStatuses(employeeId: number): UseQueryResult<DocumentStatus[], ResponseError> {
  return useQuery<DocumentStatus[], ResponseError>(
    [ENDPOINT, employeeId],
    () => client.getDocumentStatuses(employeeId),
    {
      ...RetryConfig
    }
  )
}
